import { memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useDialog } from "helper/customHook";

import {
  listEmployeeFeedbackRequestSelector,
  totalRecordsEmployeeFeedbackRequestSelector,
} from "modules/DeclareLeave/redux/selector";
import { DIALOG } from "helper/enum/dialogEnum";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";

import ViewTable from "modules/DeclareLeave/components/CustomTable";
import EmptyState from "components/common/EmptyState";
import pathRoutes from "routes/pathRoutes";
import useColumns from "./useColumn";
import ResponseDetails from "../Modals/ResponseDetail";
import { getListEmployeeFeedbackRequestStart } from "modules/DeclareLeave/redux/getListEmployeeFeedbackRequest";

export const ListFeedback = memo(() => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(listEmployeeFeedbackRequestSelector);
  const totalRecords = useSelector(totalRecordsEmployeeFeedbackRequestSelector);
  const { responseCols: columns } = useColumns();
  const viewFeedbackDetailDialog = useDialog(DIALOG.RESPONSE_DETAIL);

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      viewFeedbackDetailDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.employeeOrderLeave}/${declareLeaveURL.feedback}/${idRecord}`,
        { replace: true }
      );
    }
  };

  return (
    <>
      <ViewTable
        id="employeeFeedbackRequest"
        data={data ?? []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {
          dispatch(getListEmployeeFeedbackRequestStart());
        }}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn phản hồi nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => handleViewDetail(item.id)}
        height={500}
        isHasMore={data?.length < totalRecords}
      />

      <ResponseDetails />
    </>
  );
});
